//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
export default {
  name: "TransitionToggle",
  computed: {
    ...mapGetters(['autoAdjusting']),
  },
  methods: {
    beforeLeave(element) {
      element.style.left = `${element.offsetLeft}px`;
    },
    afterLeave(element) {
      element.style.left = ``;
    },
  }
};
